// application.js
const no = require('json!yaml!././nb.yml')

const no2 = require('json!yaml!./nb2.yml')
no.nb.vue2 = no2

export default no



// WEBPACK FOOTER //
// ./src/i18n/nb.js